'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_TIMEOUT = 1000;
var events = {};

function on (topic, handler) {
  if (typeof topic !== 'string') { throw new Error('topic must be a string') }
  if (typeof handler !== 'function') { throw new Error('Handler must be of topic function')
  ; }(events[topic] = events[topic] || []).push(handler);
}

function off (topic, handler) {
  if (typeof topic !== 'string') { throw new Error('topic must be a string') }
  events[topic] = (events[topic] || []).filter(function (fn) { return handler && fn !== handler; });
}

function once (topic, handler) {
  if (typeof topic !== 'string') { throw new Error('type must be a string') }
  if (typeof handler !== 'function') { throw new Error('Handler must be of type function') }
  var newHandler = function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    off(topic, newHandler);
    handler.apply(void 0, args);
  };
  on(topic, newHandler);
}

function emit (topic, data) {
  if ( data === void 0 ) data = {};

  if (window.webkit && window.webkit.messageHandlers) {
    window.webkit.messageHandlers.nativebridgeiOS.postMessage({topic: topic, data: data});
  } else if (window.NativeBridgeAndroid) {
    window.NativeBridgeAndroid.send(JSON.stringify({topic: topic, data: data}));
  } else {
    throw new Error('No native bridge defined')
  }
}

function validateRpcInput (ref) {
  var topic = ref.topic;
  var data = ref.data;
  var resolve = ref.resolve;
  var reject = ref.reject;
  var timeout = ref.timeout;

  if (typeof topic !== 'string') {
    throw TypeError('topic argument must be a String')
  }
  if (data === null || typeof data !== 'object') {
    throw TypeError('data argument must be an Object')
  }
  if (typeof resolve !== 'function') {
    throw new TypeError('resolve must be a function')
  }
  if (typeof reject !== 'function') {
    throw new TypeError('resolve must be a function')
  }
  if (typeof timeout !== 'number') {
    throw new TypeError('timeout must be a number')
  }
  return true
}

function rpc (ref) {
  var topic = ref.topic;
  var data = ref.data;
  var resolve = ref.resolve;
  var reject = ref.reject;
  var timeout = ref.timeout; if ( timeout === void 0 ) timeout = DEFAULT_TIMEOUT;

  try {
    validateRpcInput({topic: topic, resolve: resolve, reject: reject, data: data, timeout: timeout});
    var timedout = false;
    var timer = setTimeout(function () {
      timedout = true;
      reject(new Error(("RPC for " + topic + " using " + data + " timed out after " + timeout + "ms")));
    }, timeout);
    var done = function (args) {
      clearTimeout(timer);
      if (args.errors) { reject(new Error(JSON.stringify(args.errors))); }
      else if (!timedout) { resolve(args); }
    };
    once(topic, done);
    emit(topic, data);
  } catch (err) {
    reject(err);
  }
}

function onNative (ref) {
  var ref_detail = ref.detail;
  var topic = ref_detail.topic;
  var data = ref_detail.data;

  (events[topic] || []).forEach(function (handler) { return handler(data); });
}

function setupNativeLink () {
  window.addEventListener('nativebridge', onNative);
}

function destroy () {
  Object.keys(events).forEach(function (topic) { return (events[topic] = []); });
  if (typeof window !== 'undefined') {
    window.removeEventListener('nativebridge', onNative);
  }
}

if (typeof window !== 'undefined') { setupNativeLink(); }

exports.events = events;
exports.on = on;
exports.off = off;
exports.once = once;
exports.emit = emit;
exports.validateRpcInput = validateRpcInput;
exports.rpc = rpc;
exports.setupNativeLink = setupNativeLink;
exports.destroy = destroy;
